import { Component } from '@verndale/core';
import $ from 'jquery';
import Flickity from 'flickity';
import jQueryBridget from 'jquery-bridget';
import 'flickity-as-nav-for/as-nav-for';
import 'flickity-fade';

class Module extends Component {
  setupDefaults() {
    this.dom = {};
    Flickity.setJQuery($);
    jQueryBridget('flickity', Flickity, $);
    this.initCarousel();
  }

  addListeners() {}

  initCarousel() {
    const $calloutBoatBrands = $('section.callout-brands');
    if ($calloutBoatBrands.length) {
      $calloutBoatBrands.each(function () {
        const $calloutContainer = $(this);
          const $list = $calloutContainer.find('.callout-brands-list');
          const $listNav = $calloutContainer.find('.callout-brands-nav-list');
          let $buttons;

        function buildSlider() {
          // list flickity
          $list.flickity({
            cellAlign: 'left',
            fade: true
          });

          // navigation flickity
          $listNav.flickity({
            cellAlign: 'left',
            asNavFor: $list[0],
            pageDots: false,
            contain: true
          });

          // move buttons in parent div for positioning
          $buttons = $list.find('.flickity-button');
          $list.append(
            $('<div class="flickity-buttons"></div>').append($buttons)
          );

          $calloutContainer.addClass('ready');
        }

        buildSlider();
      });
    }
  }
}

export default Module;
